import { Circle } from '../types/content'

export const circles: Circle[] = [
  {
    slug: 'early-signals-circle',
    name: 'The Too-Young Circle',
    kind: 'Weekly circle',
    host: 'Nadia Okonkwo',
    hostRole: 'Facilitator, women’s health nurse practitioner',
    cadence: 'Tuesdays, 8:00pm ET · 60 minutes',
    nextSession: 'Tue 8 Sep',
    seatsLeft: 3,
    seatsTotal: 12,
    description:
      'For women in their thirties and early forties who have been told they are too young. Cycle changes, new anxiety, PMS that turned vicious, and how to be taken seriously by a clinician who is not us.',
  },
  {
    slug: 'the-3am-thread',
    name: 'The 3am Thread',
    kind: 'Open thread',
    host: 'Always open',
    hostRole: 'Moderated overnight',
    cadence: 'Asynchronous · no meeting, no camera',
    nextSession: 'Open now',
    seatsLeft: 0,
    seatsTotal: 0,
    description:
      'A thread that only exists because so many of you are awake at the same time. Post at 3:14am, get a reply from someone in another timezone who is also staring at the ceiling. No advice required, no camera, no small talk.',
  },
  {
    slug: 'hrt-questions',
    name: 'Hormone Therapy: Ask Anything',
    kind: 'Clinician Q&A',
    host: 'Dr Imogen Halvorsen',
    hostRole: 'MD, Menopause Society Certified Practitioner',
    cadence: 'Second Thursday monthly, 7:00pm ET · 75 minutes',
    nextSession: 'Thu 10 Sep',
    seatsLeft: 24,
    seatsTotal: 80,
    description:
      'The WHI study, breast cancer risk in actual numbers, patches versus pills, what happens if you stop. Questions can be submitted anonymously in advance and Imogen answers the uncomfortable ones first.',
  },
  {
    slug: 'body-changed',
    name: 'My Body Changed Shape',
    kind: 'Weekly circle',
    host: 'Priya Raman',
    hostRole: 'Facilitator, registered dietitian',
    cadence: 'Sundays, 11:00am ET · 60 minutes',
    nextSession: 'Sun 6 Sep',
    seatsLeft: 5,
    seatsTotal: 12,
    description:
      'Midlife metabolism, strength, and the grief of a body that no longer responds to what used to work. Explicitly not a weight loss group — no scales, no goal weights, no before and after.',
  },
  {
    slug: 'intimacy-circle',
    name: 'The Things We Don’t Say',
    kind: 'Weekly circle',
    host: 'Dr Ruth Adeyemi',
    hostRole: 'MD, pelvic health',
    cadence: 'Thursdays, 8:30pm ET · 60 minutes',
    nextSession: 'Thu 3 Sep',
    seatsLeft: 2,
    seatsTotal: 10,
    description:
      'Painful sex, dryness, leaking, desire that vanished. Cameras optional and most people keep them off. Small on purpose, so it stays a room rather than an audience.',
  },
  {
    slug: 'post-menopause',
    name: 'The Long View',
    kind: 'Weekly circle',
    host: 'Carmen Delacroix',
    hostRole: 'Facilitator, health coach',
    cadence: 'Mondays, 12:00pm ET · 45 minutes',
    nextSession: 'Mon 7 Sep',
    seatsLeft: 7,
    seatsTotal: 12,
    description:
      'For women past the transition, thinking about bones, hearts, brains and the next thirty years. Less crisis, more strategy — and a fair amount of laughing.',
  },
]

export function getCircle(slug: string): Circle | undefined {
  return circles.find((circle) => circle.slug === slug)
}
